<template>
  <div class="filter-category-page fullheight">
    <Tabs v-model="activeTab" class="fullheight filter-category-tabs" @on-click="handleOnChangeTab">
        <TabPane label="Filters" icon="md-funnel" class="filters-tabpane" name="filters">
          <Form :model="formData" label-position="top" class="filter-category-form">
            <FormItem>
              Keyword Search
              <Tooltip :transfer="true" placement="top" max-width="250">
                [?]
                <div slot="content">
                  <p>Please use comma and space to separate multiple keywords</p>
                </div>
              </Tooltip>
              <Input v-model="formData.keyword_search" class="k-input" placeholder="Email marketing, Company name, ..." clearable />
            </FormItem>
            <FormItem label="Tech Category">
              <KSelect v-model="formData.newcategory" class="k-input" placeholder="All" classes="k-select" :optionList="techCategories" :isMultiple="true" :isFilterable="true" :isLoading="catLoading"/>
            </FormItem>
            <FormItem label="Market Application" prop="marketapplication">
              <KSelect v-model="formData.marketapplication" class="k-input" placeholder="All" classes="k-select" :optionList="marketApplications" :isMultiple="true" :isFilterable="true" :isLoading="marketappLoading"/>
            </FormItem>
            <FormItem prop="address" class="_location">
              <span slot="label">
                Country
                <Tooltip max-width="300" placement="top" content="Search country in English" transfer>[?]</Tooltip>
              </span>
              <div class="mapbox-geocoder-wrapper">
                <div id="mapbox-geocoder" class="fullwidth" style="height:32px"></div>
                <Icon @click="getCurrentLocation" type="md-locate" class="clickable"/>
              </div>
            </FormItem>
            <FormItem>
              <div style="border-bottom:1px solid #dcdee2;padding-bottom:20px;" class="pos-relative">
                Responsible Company
                <Tooltip :transfer="true" placement="top" max-width="300">
                  [?]
                  <div slot="content">
                    <p>GDPR compliance, security certification,<br/>Web hosting location, CSR certifications,<br/>green initiatives & labels</p>
                  </div>
                </Tooltip>
              <Checkbox v-model="formData.responsible_company" style="position:absolute;right:0px;" size="large"></Checkbox>
              </div>
            </FormItem>
            <FormItem label="Company size" prop="categories">
              <KSelect v-model="formData.size" :optionList="company_sizes" classes="k-select" placeholder="All"/>
            </FormItem>
            <FormItem label="Founded in">
              <p style="margin-top:5px;">{{formData.founded_min}}-{{formData.founded_max}}</p>
              <Slider v-model="founded_in" range style="padding: 0px 15px;" show-tip="never" class="k-slider" :min="founded[0]" :max="founded[1]"></Slider>
            </FormItem>
            <FormItem v-if="userType == 3">
              <div class="step-con text-center width-80 margin-auto">
                <p style="color:#b00101">Step 1/5</p>
                <p style="line-height:initial;">Explore and narrow your filter results to maximum 50.</p>
              </div>
            </FormItem>
            <FormItem>
              <Row type="flex" justify="space-between" align="middle" class="text-center" :gutter="5">
                <i-col :xs="24" :sm="24" :md="24" :xl="12">
                  <Button icon="md-refresh" class="k-btn-3" style="width:110px;padding-right:7px;padding-left:7px;" @click="handleResetFilters">Reset Filters</Button>
                </i-col>
                <i-col :xs="24" :sm="24" :md="24" :xl="12">
                  <Button icon="ios-search"  class="k-btn-1" @click="handleExplore" style="width:110px;padding-right:7px;padding-left:7px;" :loading="isExploring">Explore</Button>
                </i-col>
              </Row>
            </FormItem>
            <FormItem class="text-center">
              <Button class="k-btn-2" @click="handleLoginModal" v-if="!userType" long>Log in to submit your RFP</Button>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="Categories" icon="ios-keypad" class="categories-tabpane" name="categories">
          <CardCategory @reload="handleReloadCompanies"/>
        </TabPane>
    </Tabs>
    <LoginFormModal ref="LoginFormModal" />
  </div>
</template>

<script>import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css'
import CardCategory from './CategoryCard'
import KSelect from '@/components/ui/Select'
import { fetchCategories } from '@/services/categories'
import { fetchMarketApplications } from '@/services/market-applications'
import { mapActions } from 'vuex'
import moment from 'moment'
import LoginFormModal from '@/components/auth/LoginFormModal'
import axios from 'axios'
import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'

export default {
  components: {
    KSelect,
    CardCategory,
    LoginFormModal
  },

  data () {
    return {
      mapbox_access_token: process.env.VUE_APP_MAPBOX_API_KEY,
      activeTab: 'filters',
      isExploring: false,
      founded: [1968, moment().year()],
      founded_in: [1968, moment().year()],
      formData: {
        keyword_search: null,
        newcategory: [],
        marketapplication: [],
        address: null,
        responsible_company: false,
        size: null,
        founded_min: 1968,
        founded_max: moment().year()
      },
      selectedNames: {
        newcategory_names: [],
        marketapplication_names: []
      },
      filterData: '',
      techCategories: [],
      marketApplications: [],
      userType: localStorage.getItem('userType'),
      catLoading: false,
      marketappLoading: false,
      mapboxAccessToken: process.env.VUE_APP_MAPBOX_API_KEY
    }
  },

  watch: {
    formData: {
      handler (val) {
        const query = {}
        if (val.keyword_search) query.keyword_search = val.keyword_search
        if (val.newcategory) query.newcategory = val.newcategory
        if (val.marketapplication) query.marketapplication = val.marketapplication
        if (val.address) query.address = val.address
        if (val.responsible_company) query.responsible_company = val.responsible_company
        if (val.size) query.size = val.size
        if (val.founded_min > 1968 || val.founded_max < moment().year()) {
          query.founded_min = val.founded_min
          query.founded_max = val.founded_max
        }

        if (val.newcategory.length) {
          this.selectedNames.newcategory_names = []
          val.newcategory.map(i => {
            const selected = this.techCategories.find(x => x.value === i).label
            this.selectedNames.newcategory_names.push(selected.replace('_ ', ''))
          })
        }

        if (val.marketapplication.length) {
          this.selectedNames.marketapplication_names = []
          val.marketapplication.map(i => {
            this.selectedNames.marketapplication_names.push(this.marketApplications.find(x => x.value === i).label)
          })
        }

        this.$router.replace({ query: query })
        this.filterData = window.location.search
        this.setTechProvidersFilters(this.filterData)
        this.setRequestRfpFilters({ ...this.formData, ...this.selectedNames })
        this.$emit('explore')
      },
      deep: true
    },
    founded_in: {
      handler (val) {
        this.formData.founded_min = val[0]
        this.formData.founded_max = val[1]
      }
    }
  },

  mounted () {
    if (this.$route.name === 'company-explore' && this.$route.query.tab !== 'categories') {
      this.activeTab = 'filters'
    } else {
      this.activeTab = 'categories'
    }
    if (this.$route.query) {
      if (this.$route.query.keyword_search) this.formData.keyword_search = this.$route.query.keyword_search
      if (this.$route.query.newcategory) {
        if (Array.isArray(this.$route.query.newcategory)) {
          this.formData.newcategory = this.$route.query.newcategory.map(i => Number(i))
        } else {
          this.formData.newcategory = [Number(this.$route.query.newcategory)]
        }
      }
      if (this.$route.query.marketapplication) {
        if (Array.isArray(this.$route.query.marketapplication)) {
          this.formData.marketapplication = this.$route.query.marketapplication.map(i => Number(i))
        } else {
          this.formData.marketapplication = [Number(this.$route.query.marketapplication)]
        }
      }
      if (this.$route.query.address) this.formData.address = this.$route.query.address
      if (this.$route.query.responsible_company) this.formData.responsible_company = JSON.parse(this.$route.query.responsible_company)
      if (this.$route.query.size) this.formData.size = this.$route.query.size
      if (this.$route.query.founded_min) this.formData.founded_min = this.$route.query.founded_min
      if (this.$route.query.founded_max) this.formData.founded_max = this.$route.query.founded_max
      if (this.$route.query.founded_min && this.$route.query.founded_max) this.founded_in = [this.$route.query.founded_min, this.$route.query.founded_max]
      this.filterData = window.location.search
      this.handleExplore()
    }
    this.getTechCategories()
    this.getMarketApplications()
    this.renderMapBoxGeocoder()

    if (this.$route.query.address) document.querySelectorAll('.mapboxgl-ctrl-geocoder--input')[0].value = this.$route.query.address
  },

  methods: {
    ...mapActions(
      {
        setTechProvidersFilters: 'techProviders/setTechProvidersFilters',
        setRequestRfpFilters: 'techProviders/setRequestRfpFilters'
      }
    ),

    renderMapBoxGeocoder () {
      const vm = this
      mapboxgl.accessToken = this.mapboxAccessToken
      var geocoder = new MapboxGeocoder({
        accessToken: this.mapboxAccessToken,
        types: 'country,region,place,postcode,locality,neighborhood, address, poi',
        countries: 'AL, AD, AM, AT, BY, BE, BA, BG, CH, CY, CZ, DE, DK, EE, ES, FO, FI, FR, GB, GE, GI, GR, HU, HR, IE, IS, IT, LT, LU, LV, MC, MK, MT, NO, NL, PL, PT, RO, RU, SE, SI, SK, SM, TR, UA, VA, RS, MD, ME, LI',
        mapboxgl: mapboxgl,
        language: 'en',
        placeholder: 'All'
      })

      geocoder.addTo('#mapbox-geocoder')

      geocoder.on('result', function (e) {
        const res = JSON.stringify(e.result, null, 2)
        vm.formData.address = JSON.parse(res).place_name
      })

      geocoder.on('clear', function () {
        vm.formData.address = ''
      })
    },

    getTechCategories () {
      this.techCategories = []
      this.catLoading = true
      fetchCategories().then(res => {
        this.techCategories = res.data.results.reduce((acc, cur) => {
          acc.push({
            value: cur.id,
            label: cur.name
          })
          if (cur.subcategories && cur.subcategories.length > 0) {
            cur.subcategories.map(item => {
              acc.push({
                value: item.id,
                label: '_ ' + item.name
              })
              if (item.subcategories && item.subcategories.length > 0) {
                item.subcategories.map(item => {
                  acc.push({
                    value: item.id,
                    label: '_ _ ' + item.name
                  })
                })
              }
            })
          }
          return acc
        }, [])
      }).catch(err => {
        console.log('Failed to fetch tech categories: ', err)
      })
      this.catLoading = false
    },

    getMarketApplications () {
      this.marketApplications = []
      this.marketappLoading = true
      fetchMarketApplications().then(res => {
        this.marketApplications = res.data.results.reduce((acc, cur) => {
          acc.push({
            value: cur.id,
            label: cur.name
          })
          return acc
        }, [])
      }).catch(err => {
        console.log('Failed to fetch tech categories: ', err)
      })
      this.marketappLoading = false
    },

    handleExplore () {
      this.isExploring = true
      this.setTechProvidersFilters(this.filterData)
      this.setRequestRfpFilters({ ...this.formData, ...this.selectedNames })
      this.$emit('explore')
      setTimeout(() => {
        this.isExploring = false
      }, 3000)
    },

    handleReloadCompanies (catId) {
      this.$emit('explore', catId)
    },

    handleLoginModal () {
      this.$refs.LoginFormModal.openModal()
    },

    handleResetFilters () {
      this.formData = {
        keyword: null,
        newcategory: [],
        marketapplication: [],
        address: null,
        responsible_company: null,
        size: null,
        founded: null
      }
      this.selectedNames = {
        newcategory_names: [],
        marketapplication_names: []
      }
      this.filterData = ''
      window.location.href = process.env.VUE_APP_BASE_URL
      this.handleExplore()
    },

    async getCurrentLocation () {
      try {
        const vm = this
        await navigator.geolocation.getCurrentPosition(
          async position => {
            const response = await axios.get(`${process.env.VUE_APP_MAPBOX_API_URL}${position.coords.longitude},${position.coords.latitude}.json?access_token=${vm.mapboxAccessToken}`)
            vm.formData.address = response.data.features[0].place_name
            document.querySelectorAll('.mapboxgl-ctrl-geocoder--input')[0].value = response.data.features[0].place_name
          },
          error => {
            console.log(error.message)
          }
        )
      } catch (err) {
        console.log(err)
      }
    },

    handleOnChangeTab (name) {
      if (name === 'categories') {
        this.$router.replace({
          name: 'company-explore',
          query: {
            tab: 'categories'
          }
        })
        this.setTechProvidersFilters()
        this.setRequestRfpFilters()
        this.$emit('explore')
      } else {
        if (this.filterData) {
          const query = {}
          if (this.formData.keyword_search) query.keyword_search = this.formData.keyword_search
          if (this.formData.newcategory) query.newcategory = this.formData.newcategory
          if (this.formData.marketapplication) query.marketapplication = this.formData.marketapplication
          if (this.formData.address) query.address = this.formData.address
          if (this.formData.responsible_company) query.responsible_company = this.formData.responsible_company
          if (this.formData.size) query.size = this.formData.size
          if (this.formData.founded_min) query.founded_min = this.formData.founded_min
          if (this.formData.founded_max) query.founded_max = this.formData.founded_max

          this.$router.replace({ query: query })
          this.filterData = window.location.search

          this.setTechProvidersFilters(this.filterData)
          this.setRequestRfpFilters({ ...this.formData, ...this.selectedNames })
          this.$emit('explore')
        } else {
          this.$router.replace({
            name: 'company-explore',
            query: {
              tab: 'filters'
            }
          })
          this.$emit('explore')
        }
      }
    }
  }
}
</script>

<style lang="scss">
.filter-category-form {
  .ivu-form-item-label {
    padding: 0px;
    text-align: left;
  }
  .ivu-input::placeholder,
  .ivu-select input::placeholder,
  .mapboxgl-ctrl-geocoder--input::placeholder {
    font-style: italic;
    color: #dcdee2;
  }
  .ivu-select-selection {
    font-style: italic;
  }
}

.filter-category-page {
  .filter-category-tabs {
    .ivu-tabs-content {
      height: calc(100% - 50px);
      .ivu-tabs-tabpane {
        height: 100%;
        overflow-y: scroll;
        overflow: auto;
        padding: 0px 20px;
      }
    }
  }
}
._location {
  &::after {
    display: none;
  }
}
</style>
